<template>
  <section class="hero section">
    <div class="hero__container section__container container">
      <MainHeading>
        Обеспечьте себе пассивный доход
      </MainHeading>
      <p class="hero__text p-reset">
        Регистрируйтесь. Привлекайте&nbsp;клиентов. Получайте&nbsp;доход.
      </p>
      <GetPartnerBtn class="hero__link" />
    </div>
  </section>
</template>

<style scoped>
.hero {
  padding-top: 168px;
  padding-bottom: 134px;
  background: linear-gradient(
      91.79deg,
      rgba(0, 0, 0, 0.8) 39.35%,
      rgba(0, 0, 0, 0.48) 71.88%,
      rgba(0, 0, 0, 0) 104.86%
    ),
    url(@/assets/img/hero.jpg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border: 1px solid #000000;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  color: var(--white);
}

.hero__text {
  margin-bottom: 86px;
}

@media (max-width: 960px) {
  .hero {
    padding-top: 140px;
    padding-bottom: 80px;
  }

  .hero__text {
    max-width: 80%;
    margin-bottom: 50px;
  }
}

@media (max-width: 769px) {
  .hero {
    padding-top: 90px;
    padding-bottom: 50px;
  }
}

@media (max-width: 600px) {
  .hero {
    padding-top: 70px;
    padding-bottom: 40px;
  }
}
</style>

<script>
import MainHeading from '@/components/MainHeading.vue'
import GetPartnerBtn from '@/components/GetPartnerBtn.vue'

export default {
  components: { MainHeading, GetPartnerBtn }
}
</script>
